import { Component, OnInit } from '@angular/core';
import {AngularFireAuth} from '@angular/fire/auth';
import {CardService} from '../../shared/card.service';
import {CouponService} from '../../shared/coupon.service';
import {AngularFirestore} from '@angular/fire/firestore';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {RecensioniService} from '../../shared/recensioni.service';

@Component({
  selector: 'app-recensione',
  templateUrl: './recensione.component.html',
  styleUrls: ['./recensione.component.css']
})
export class RecensioneComponent implements OnInit {

  constructor(public afAuth: AngularFireAuth , private recensioniService: RecensioniService,
              private firestore: AngularFirestore, public router: Router) { }
  recensioni;

  ngOnInit(){
    this.ReturnRecensioni();
  }


  ReturnRecensioni = () =>
      this.recensioniService
          .getRecensioni()
          .subscribe(res => (this.recensioni = res))
}
